import * as R from "ramda";

export const insertAds = (items, ad1, ad2, callback) => {
  if (items.length > 13) {
    callback(2);
    return R.compose(
      R.unless(
        () => (ad2 ? false : true),
        R.insert(12, { ...ad2, type: "ad" }),
      ),
      R.unless(() => (ad1 ? false : true), R.insert(8, { ...ad1, type: "ad" })),
    )(items);
  } else if (items.length > 9) {
    callback(1);
    return R.unless(
      () => (ad1 ? false : true),
      R.insert(8, { ...ad1, type: "ad" }),
    )(items);
  } else {
    return items;
  }
};

export const insertAdsAndManualPeople = (
  items,
  extraPeople,
  peopleCallback,
  ad1,
  ad2,
  adsCallback,
) => {
  peopleCallback(extraPeople.length);
  return R.compose(
    (results) => insertAds(results, ad1, ad2, adsCallback),
    R.concat(extraPeople),
  )(items);
};
